import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Chapter } from "../components/Chapter";
import { RealScreen } from "../components/UIFragment";
import { IMG } from "../lib/scenes";

const EASE = [0.16, 1, 0.3, 1];

// Deliveries — the day arrives.
export const SceneDeliveries = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const winY = useTransform(scrollYProgress, [0, 1], ["5%", "-5%"]);

  return (
    <section
      id="deliveries"
      data-scene
      ref={ref}
      className="relative px-6 py-14 md:px-12 md:py-24 lg:px-24"
    >
      <div className="mx-auto w-full max-w-[1600px]">
        <Chapter title="Deliveries" />

        <div className="max-w-4xl">
          <h2 className="font-display text-6xl font-black leading-[0.92] tracking-tighter text-[#1b1a18] sm:text-7xl">
            The day starts at the back door.
          </h2>
          <p className="mt-6 max-w-xl font-body text-xl leading-relaxed text-[#6b665e]">
            What arrived. What’s running low. What to prep today.
          </p>
        </div>

        <div className="relative mt-10">
          <div className="overflow-hidden rounded-2xl">
            <img
              src={IMG.deliveries}
              alt="Fresh ingredients arriving in the kitchen in the morning"
              className="aspect-[16/9] w-full object-cover"
              loading="lazy"
            />
          </div>

          <motion.div
            style={{ y: winY }}
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-12%" }}
            transition={{ duration: 0.9, ease: EASE }}
            className="relative z-10 mx-auto -mt-20 w-full max-w-5xl md:-mt-32 lg:-mr-4 lg:ml-auto lg:mt-[-14rem]"
          >
            <RealScreen
              src="/generated/real_receiving.webp"
              alt="MiseOne — Deliveries: reviewing what arrived at the back door"
              testId="deliveries-app-screenshot"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
